if (window.matchMedia('(max-width: 959px)').matches) {
    $(".module-search .form-search .button.button-search").on("click", function(e) {
        if (!$(".item-search").hasClass("fly-out")) {
            e.preventDefault();
            $(".item-search").addClass("fly-out");
            $(".module-search .form-search .input-text").show();
            $(".module-search .form-search .input-text").focus();
            $(".module-search .form-search .button.button-search").after('<button class="button button-close"><i class="fa fa-times"></i></button>');
        }
    });
}

$(document).on("click", ".module-search .button-close", function(e) {
    e.preventDefault();
    $(".item-search").removeClass("fly-out");
    $(".button-close").remove();
    $(".module-search .form-search .input-text").hide();
});

$(document).ready(function() {
    const targetNode = document.getElementById("messages_product_view");
    if (targetNode) {
        const observer = new MutationObserver(function(mutationsList) {
            for (let mutation of mutationsList) {
                if (mutation.type === "childList" || mutation.type === "characterData") {
                    // console.log("Div content has changed:", targetNode.innerHTML);
                    if (targetNode.innerHTML.includes("Item has been added to your cart")) {
                        targetNode.style.opacity = "0";
                    }

                    if (targetNode.innerHTML.includes("Your product has been added to the cart")) {
                        targetNode.style.opacity = "0";
                    }
                }
            }
        });

        const config = { childList: true, subtree: true, characterData: true };
        observer.observe(targetNode, config);
    }

    $(".module-basket-summary").addClass("clickable-dropdown").removeClass("dropdown");

    $(".module-basket-summary .dropdown-toggle").on("click", function(e) {
        e.preventDefault();
        e.stopPropagation();
        var $dropdown = $(this).parent(".module-basket-summary");
        $dropdown.toggleClass("open");

        if ($dropdown.hasClass("open")) {
            addBackdrop();
        }
    });

    // Add tracking variables at the start of ready function
    let pendingAddToCartCalls = 0;
    let isProcessing = false;
    let debounceTimer = null;
    const DEBOUNCE_DELAY = 500;

    // Track new_add_to_cart calls
    $(document).ajaxSend(function(event, xhr, settings) {
        if (settings.url === "/ajax/new_add_to_cart/") {
            pendingAddToCartCalls++;
            // console.log("New add to cart call started. Pending calls:", pendingAddToCartCalls);
        } 
        
        // else if (settings.url === "/ajax/add_to_cart_post_process/") {
        //     console.log("Post process started. Pending add to cart calls:", pendingAddToCartCalls);
        //     addBackdrop();
        // }
    });

    // Track completion of new_add_to_cart calls
    $(document).ajaxComplete(function(event, xhr, settings) {
        if (settings.url === "/ajax/new_add_to_cart/") {
            pendingAddToCartCalls = Math.max(0, pendingAddToCartCalls - 1);
            // console.log("New add to cart call completed. Remaining calls:", pendingAddToCartCalls);
        } else if (settings.url === "/ajax/add_to_cart_post_process/") {
            // console.log("Post process completed. Pending add to cart calls:", pendingAddToCartCalls);
            
            // Only process if all new_add_to_cart calls are complete
            if (pendingAddToCartCalls === 0) {
                // Clear any existing timer
                if (debounceTimer) {
                    clearTimeout(debounceTimer);
                }

                // Set a new timer
                debounceTimer = setTimeout(() => {
                    if (!isProcessing) {
                        isProcessing = true;
                        
                        try {
                            const response = JSON.parse(xhr.responseText);
                            const basketData = response.basketData;

                            if (basketData.item_count > 0) {
                                $(".module-basket-summary__cart-totals").show();
                            }
                            
                            // Update subtotal
                            const subtotalElement = $('.preview-cart-total.subTotal .preview-cart-total-value');
                            subtotalElement.html(`<span class="money">${basketData.priceTag}${basketData.sub_total}</span>`);
                            subtotalElement.attr('data-cart-subtotal', basketData.sub_total);

                            // Update total
                            const totalElement = $('.preview-cart-total.total .preview-cart-total-value');
                            totalElement.html(`<span class="money">${basketData.priceTag}${basketData.grandTotal}</span>`);
                            totalElement.attr('data-cart-total-value', basketData.grandTotal);

                            var $dropdown = $(".module-basket-summary");
                            $dropdown.toggleClass("open");

                            if ($dropdown.hasClass("open")) {
                                addBackdrop();
                            }
                        } catch (error) {
                            console.error('Error updating cart totals:', error);
                        } finally {
                            isProcessing = false;
                        }
                    }
                }, DEBOUNCE_DELAY);
            } else {
                console.log("Skipping cart update - waiting for remaining add to cart calls to complete");
            }
        } else if (settings.url === "/ajax/item_configurator_ajax/addToCart") {
            // Handle item configurator add to cart
            try {
                const response = JSON.parse(xhr.responseText);

                const basketData = response.basketData;

                if (basketData.item_count > 0) {
                    $(".module-basket-summary__cart-totals").show();
                }
                
                // Update subtotal
                const subtotalElement = $('.preview-cart-total.subTotal .preview-cart-total-value');
                subtotalElement.html(`<span class="money">${basketData.priceTag}${basketData.sub_total}</span>`);
                subtotalElement.attr('data-cart-subtotal', basketData.sub_total);

                // Update total
                const totalElement = $('.preview-cart-total.total .preview-cart-total-value');
                totalElement.html(`<span class="money">${basketData.priceTag}${basketData.grandTotal}</span>`);
                totalElement.attr('data-cart-total-value', basketData.grandTotal);

                var $dropdown = $(".module-basket-summary");
                $dropdown.toggleClass("open");

                if ($dropdown.hasClass("open")) {
                    addBackdrop();
                }
            } catch (error) {
                console.error('Error updating cart totals for item configurator:', error);
            }
        } else if (settings.url === "/ajax/remove_from_cart") {
            // console.log("=== Remove from cart AJAX complete ===");
            try {
                const response = JSON.parse(xhr.responseText);
                // console.log("Response:", response);
                
                // Update subtotal
                const subtotalElement = $('.preview-cart-total.subTotal .preview-cart-total-value');
                subtotalElement.html(`<span class="money">${response.priceTag}${response.sub_total}</span>`);
                subtotalElement.attr('data-cart-subtotal', response.sub_total);

                // Update total
                const totalElement = $('.preview-cart-total.total .preview-cart-total-value');
                totalElement.html(`<span class="money">${response.priceTag}${response.grandTotal}</span>`);
                totalElement.attr('data-cart-total-value', response.grandTotal);

                // If cart is empty, close the dropdown
                if (response.item_count === 0) {
                    // console.log("Cart is empty, removing backdrop");
                    $(".module-basket-summary.open").removeClass("open");
                    removeBackdrop();
                }
            } catch (error) {
                console.error('Error updating cart totals:', error);
            }
        }
    });

    $(document).on("click", function(e) {
        var $openDropdown = $(".module-basket-summary.open");
        
        // console.log('=== Document click handler ===');
        // console.log('Click target:', e.target);
        // console.log('Target classes:', $(e.target).attr('class'));
        // console.log('Is inside dropdown-menu:', $(e.target).closest(".module-basket-summary .dropdown-menu").length > 0);
        // console.log('Open dropdown count:', $openDropdown.length);

        if ($openDropdown.length && 
            !$(e.target).closest(".module-basket-summary .dropdown-menu").length
            // !$(e.target).closest(".module-basket-summary .dropdown-toggle").length &&
            // $(e.target).hasClass('dropdown-backdrop')
        ) {
            $openDropdown.removeClass("open");
            removeBackdrop();
        }
    });

    $(".module-basket-summary .dropdown-menu").on("click", ".close-pop", function(e) {
        // console.log("close-pop clicked");
        var $openDropdown = $(".module-basket-summary.open");
        $openDropdown.removeClass("open");
        removeBackdrop();
    });


    $(".module-basket-summary .dropdown-menu").on("click", function(e) {
        // console.log("dropdown-menu clicked");
        if (!$(e.target).closest('.btn-remove').length) {
            e.stopPropagation();
        }
    });

    function addBackdrop() {
        if ($(".ella-cart-backdrop").length === 0) {
            $('<div class="ella-cart-backdrop"></div>').appendTo(".module-basket-summary").fadeIn(200);
            $('body').css('overflow-y', 'hidden');
            $("body").addClass("module-basket-summary__transition");
        }
    }

    function removeBackdrop() {
        // console.log("=== removeBackdrop called ===");
        // console.log("Stack trace:", new Error().stack);
        // console.log("removing backdrop, triggered by:", event?.target || 'unknown trigger');
        
        $(".ella-cart-backdrop").fadeOut(200, function() {
            // console.log("Backdrop fadeOut complete");
            $(this).remove();
        });
        $('body').css('overflow-y', 'initial');
        
        $("body").on("transitionend", function() {
            // console.log("Body transition ended");
            $(this).removeClass("module-basket-summary__transition");
        });
    }
});

// Remove default Bootstrap dropdown behavior
$(document).off("click.bs.dropdown.data-api", ".dropdown form");

// Remove any existing hover events
$(".module-basket-summary").off("mouseenter mouseleave");

$(".module-product-details__cartButton .add-cart-button").addClass("cb-animate--horizontal-shaking");

// Also add logging to the btn-remove click handler
// $(document).on("click", ".btn-remove", function(e) {
//     console.log("=== btn-remove clicked ===");
//     console.log("Current item count in cart:", /* add your cart count here */);
// });
